abstract class SiteNavigation
    extends QueryElement<HTMLElement> {

    constructor() {
        let element = document.createElement("div");
        element.id = "navigation";

        super(element)
    }

    abstract isActive(): boolean;
    abstract makeActive(): this;
    abstract makeInactive(): this;
}